export const engagementCanvasMessageVariationsForUcoCanvasIdStepId =
  "/engagement/canvas_message_variations_for_uco/:canvas_id/:step_id";
